import { makeStyles } from '@material-ui/styles';
import { EventType } from '../../../types';
import { ITheme } from '../../../style/theme';

interface HeaderStyleProps {
  offeringType: EventType;
}

export const useStyles = makeStyles<ITheme, HeaderStyleProps>(
  (theme: ITheme) => ({
    header: {
      height: 69,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: ({ offeringType }: HeaderStyleProps) =>
        theme.eventColors[offeringType],
      borderRadius: '16px 16px 0px 0px',
      color: theme.palette.common.white,
      margin: '0 -24px',
    },
    headerLabel: {
      fontWeight: 700,
    },
  }),
);

export default useStyles;
